import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary';
  withArrow?: boolean;
}
export function Button({
  children,
  variant = 'primary',
  withArrow = false,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center px-5 py-2.5 text-sm font-medium rounded-full transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-navy-950';
  const variants = {
    primary: 'bg-white text-navy-950 hover:bg-slate-100 focus:ring-white shadow-[0_0_20px_-5px_rgba(255,255,255,0.3)] hover:shadow-[0_0_25px_-5px_rgba(255,255,255,0.5)]',
    secondary: 'bg-navy-900 text-white border border-slate-800 hover:border-slate-700 hover:bg-navy-800 focus:ring-slate-700'
  };
  return <motion.button className={`${baseStyles} ${variants[variant]} ${className}`} whileTap={{
    scale: 0.98
  }} {...props} data-id="element-44">
      {children}
      {withArrow && <ArrowRightIcon className="ml-2 w-4 h-4" data-id="element-45" />}
    </motion.button>;
}